import React from 'react'

export default () => (
  <svg viewBox="0 0 15 14">
    <path fillRule="evenodd" clipRule="evenodd" d="M2.343 6.786v6.363h3.03V9.513H9.01v3.636h3.03V6.786h.606v6.97H1.737v-6.97h.606zm6.06 3.333H5.98v3.03h2.424v-3.03zM7.193.333l6.858 5.612-.383.469-6.475-5.298L.717 6.414l-.384-.47L7.192.335z"/>
  </svg>
)
